const profile = {
  namespaced: true,
  state: {
    tableConfig: {}
  },
  getters: {
    tableConfig: (state) => (key) => state.tableConfig[key]
  },
  mutations: {
    setTableConfig(state, { key, config }) {
      if (config) {
        state.tableConfig[key] = config;
      } else {
        delete state.tableConfig[key];
      }
    }
  },
  actions: {
    setTableConfig({ commit }, payload) {
      commit("setTableConfig", payload);
    }
  }
};
export {
  profile as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZmlsZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0b3JlL3Byb2ZpbGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICBuYW1lc3BhY2VkOiB0cnVlLFxuICBzdGF0ZToge1xuICAgIHRhYmxlQ29uZmlnOiB7fSxcbiAgfSxcbiAgZ2V0dGVyczoge1xuICAgIHRhYmxlQ29uZmlnOiAoc3RhdGUpID0+IChrZXkpID0+IHN0YXRlLnRhYmxlQ29uZmlnW2tleV0sXG4gIH0sXG4gIG11dGF0aW9uczoge1xuICAgIHNldFRhYmxlQ29uZmlnKHN0YXRlLCB7IGtleSwgY29uZmlnIH0pIHtcbiAgICAgIGlmIChjb25maWcpIHtcbiAgICAgICAgc3RhdGUudGFibGVDb25maWdba2V5XSA9IGNvbmZpZztcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIGRlbGV0ZSBzdGF0ZS50YWJsZUNvbmZpZ1trZXldO1xuICAgICAgfVxuICAgIH0sXG4gIH0sXG4gIGFjdGlvbnM6IHtcbiAgICBzZXRUYWJsZUNvbmZpZyh7IGNvbW1pdCB9LCBwYXlsb2FkKSB7XG4gICAgICBjb21taXQoXCJzZXRUYWJsZUNvbmZpZ1wiLCBwYXlsb2FkKTtcbiAgICB9LFxuICB9LFxufTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFlLFVBQUE7QUFBQSxFQUNiLFlBQVk7QUFBQSxFQUNaLE9BQU87QUFBQSxJQUNMLGFBQWEsQ0FBRTtBQUFBLEVBQ2hCO0FBQUEsRUFDRCxTQUFTO0FBQUEsSUFDUCxhQUFhLENBQUMsVUFBVSxDQUFDLFFBQVEsTUFBTSxZQUFZLEdBQUc7QUFBQSxFQUN2RDtBQUFBLEVBQ0QsV0FBVztBQUFBLElBQ1QsZUFBZSxPQUFPLEVBQUUsS0FBSyxPQUFNLEdBQUk7QUFDckMsVUFBSSxRQUFRO0FBQ1YsY0FBTSxZQUFZLEdBQUcsSUFBSTtBQUFBLE1BQ2pDLE9BQWE7QUFDTCxlQUFPLE1BQU0sWUFBWSxHQUFHO0FBQUEsTUFDcEM7QUFBQSxJQUNLO0FBQUEsRUFDRjtBQUFBLEVBQ0QsU0FBUztBQUFBLElBQ1AsZUFBZSxFQUFFLE9BQVEsR0FBRSxTQUFTO0FBQ2xDLGFBQU8sa0JBQWtCLE9BQU87QUFBQSxJQUNqQztBQUFBLEVBQ0Y7QUFDSDsifQ==
